// extracted by mini-css-extract-plugin
module.exports = {"secure-checkout":"B7FXA9","secureCheckout":"B7FXA9","secure-checkout-lock":"RtnbAi","secureCheckoutLock":"RtnbAi","secure-checkout-text":"R7fI7D","secureCheckoutText":"R7fI7D"};